var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.74255 0.691211C9.0419 -0.2301 10.3453 -0.2301 10.6447 0.691211L12.2475 5.62409C12.3813 6.03611 12.7653 6.31507 13.1985 6.31507H18.3852C19.354 6.31507 19.7567 7.55469 18.973 8.12409L14.7769 11.1728C14.4264 11.4274 14.2797 11.8788 14.4136 12.2908L16.0164 17.2237C16.3157 18.145 15.2613 18.9111 14.4775 18.3417L10.2814 15.293C9.9309 15.0384 9.45631 15.0384 9.10582 15.293L4.90966 18.3417C4.12594 18.9111 3.07147 18.145 3.37082 17.2237L4.97361 12.2908C5.10748 11.8788 4.96082 11.4274 4.61034 11.1728L0.414177 8.12409C-0.369537 7.55469 0.0332392 6.31507 1.00196 6.31507H6.1887C6.62193 6.31507 7.00588 6.03611 7.13976 5.62409L8.74255 0.691211Z",
    fill: "#EC994B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar2);
export default __webpack_public_path__ + "static/media/Star2.00fa3a053798d6d3373e10ff34592228.svg";
export { ForwardRef as ReactComponent };